import React, { useEffect, useState } from "react";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface GoalsCompletedPercentageMetricState {
  data: any;
  readOnly?: boolean;
  setSelectedData: (data: any[] | null) => void;
  setDataHeaders: (data: any[] | null) => void;
  active?: boolean;
  onHandleClick?: any;
}

export const GoalsCompletedPercentageMetric = ({
  data,
  readOnly = true,
  setSelectedData,
  setDataHeaders,
  active,
  onHandleClick,
}: GoalsCompletedPercentageMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [casesCompletingGoals, setCasesCompletingGoals] = useState<any[]>();
  const [percent, setPercent] = useState<string>();

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name" },
    { label: "Goals Completed", key: "goals_completed" },
  ];

  useEffect(() => {
    if (data) {
      const { goals, caseRange } = data;
      const completingCases = uniqueCasesWithCompletedGoals(goals);
      setCasesCompletingGoals(completingCases);
      const percentage = ((completingCases?.length / caseRange?.length) * 100).toFixed(1);
      setPercent(percentage.toString());
    }
    setIsLoading(false);
  }, [data]);

  const uniqueCasesWithCompletedGoals = (sortedGoals: any[]) =>
    Object.values(
      sortedGoals
        .filter((g: any) => g.completed_at)
        .reduce((acc: any, g: any) => {
          if (acc[g.case_id]) {
            acc[g.case_id].goals_completed++;
          } else {
            acc[g.case_id] = { case_id: g.case_id, case_name: g.case_name, goals_completed: 1 };
          }
          return acc;
        }, {}),
    );

  const onViewDetails = () => {
    if (!active) {
      setSelectedData(casesCompletingGoals || null);
    } else {
      setSelectedData(null);
    }

    setDataHeaders(tableHeaders);
    onHandleClick();
  };

  if (readOnly) {
    return <SingleCardMetric title={"Case Goal Completion %"} total={percent} isLoading={isLoading} />;
  } else {
    return (
      <SingleCardMetric
        title={"Case Goal Completion %"}
        total={percent}
        onHandleClick={onViewDetails}
        cursor={true}
        active={active}
        isLoading={isLoading}
      />
    );
  }
};
